import React from 'react';
import CommonPageHeader from '../../../components/CommonPageHeader/CommonPageHeader';
import PageHelmet from '../../../components/shared/PageHelmet';
import MainFooter from '../../../components/MainFooter/MainFooter';
import NavHeader from '../../../components/NavHeader/NavHeader';
import KeyFeatures from '../KeyFeatures/KeyFeatures';
import OurApproach from '../../Home/OurApproach/OurApproach';
import AdditionalServices from '../AdditionalServices/AdditionalServices';
import { Database, Boxes, ArrowRightLeft, BarChart3, Table2, Gauge, Network, ShieldCheck, Cpu, LifeBuoy } from 'lucide-react';
import OurExpertise from '../../../components/OurExpertise/OurExpertise';
import { Link } from 'react-router-dom';

const OurExpertiseData = [
    {
        id: 1,
        title: "PostgreSQL & SQL Database Development",
        icon: <Database size="64" strokeWidth='1' />,
        content: "Well-designed PostgreSQL and SQL databases that stay reliable and fast as your data grows."
    },
    {
        id: 2,
        title: "Database Architecture & Optimization",
        icon: <Boxes size="64" strokeWidth='1' />,
        content: "Schema design and query optimization that keeps your applications responsive under real-world load."
    },
    {
        id: 3,
        title: "Data Migration Services",
        icon: <ArrowRightLeft size="64" strokeWidth='1' />,
        content: "Safe, well-tested migrations between databases and platforms with minimal downtime."
    },
    {
        id: 4,
        title: "Reporting, Analytics & Data Integration",
        icon: <BarChart3 size="64" strokeWidth='1' />,
        content: "Turn raw data into reporting and analytics your team can act on, integrated across your systems."
    }
]

const KeyFeaturesData = [
    {
        id: 1,
        title: "PostgreSQL Development",
        icon: <Database size="42" strokeWidth='1' />,
        content: "Production-grade PostgreSQL databases built for reliability."
    },
    {
        id: 2,
        title: "SQL Database Design",
        icon: <Table2 size="42" strokeWidth='1' />,
        content: "Clean, normalized schema design tailored to your application."
    },
    {
        id: 3,
        title: "Database Architecture",
        icon: <Boxes size="42" strokeWidth='1' />,
        content: "Architecture decisions that support scale from day one."
    },
    {
        id: 4,
        title: "Database Optimization",
        icon: <Gauge size="42" strokeWidth='1' />,
        content: "Query and index tuning that keeps performance predictable."
    },
    {
        id: 5,
        title: "Data Migration",
        icon: <ArrowRightLeft size="42" strokeWidth='1' />,
        content: "Migrate data between systems safely, with validation at every step."
    },
    {
        id: 6,
        title: "Reporting & Analytics",
        icon: <BarChart3 size="42" strokeWidth='1' />,
        content: "Dashboards and reports that surface the metrics that matter."
    },
    {
        id: 7,
        title: "Data Integration",
        icon: <Network size="42" strokeWidth='1' />,
        content: "Connect data across your applications, tools, and platforms."
    }
]

const AdditionalServicesData = [
    {
        id: 1,
        title: "Data Security & Backup",
        icon: <ShieldCheck size="54" strokeWidth='1' />,
        content: "Backup strategies and access controls that keep your data safe."
    },
    {
        id: 2,
        title: "Query Optimization",
        icon: <Cpu size="54" strokeWidth='1' />,
        content: "Tune slow queries so your applications stay fast as data volumes grow."
    },
    {
        id: 3,
        title: "Ongoing Database Support",
        icon: <LifeBuoy size="54" strokeWidth='1' />,
        content: "Continuous monitoring and support for your production databases."
    }
]

const OurApproachData = [
    {
        id: 1,
        title: <h3><Link to="/">Discovery</Link></h3>,
        img: "assets/img/project/discover_icon_white.svg",
        content: "Understand your goals through collaborative sessions."
    },
    {
        id: 2,
        title: <h3><Link to="/">Design</Link></h3>,
        img: "assets/img/project/design_icon_white.svg",
        content: "Deliver wireframes, prototypes, and scalable architectures focused on usability and performance."
    },
    {
        id: 3,
        title: <h3><Link to="/">Development</Link></h3>,
        img: "assets/img/project/develop_icon_white.svg",
        content: "Deliver wireframes, prototypes, and scalable architectures focused on usability and performance."
    },
    {
        id: 4,
        title: <h3><Link to="/">Quality Assurance</Link></h3>,
        img: "assets/img/project/define_icon_white.svg",
        content: "Ensure flawless functionality on all devices and platforms."
    },
    {
        id: 5,
        title: <h3><Link to="/">Launch & Support</Link></h3>,
        img: "assets/img/project/deliver_icon_white.svg",
        content: "Seamless deployment, app store submissions, and ongoing maintenance."
    }
]
const bgColors = ["#006ce0", "#001133", "#006ce0", "#001133", "#006ce0"];

const DatabaseDataSolutions = () => {
    return (
        <>
            <PageHelmet
                pageTitle="Database & Data Solutions"
                description="Harsoft Solutions delivers database and data solutions — PostgreSQL and SQL development, database architecture and optimization, data migration, and reporting & analytics."
                keywords="Database Solutions, PostgreSQL Development, SQL, Database Architecture, Data Migration, Reporting & Analytics"
                path="/database-data-solutions"
            />

            <NavHeader />
            <main>
                <CommonPageHeader title="Database & Data Solutions" subtitle="Database & Data Solutions" />
                <OurExpertise OurExpertiseData={OurExpertiseData} title="Our Expertise" subtitle="Data Infrastructure You Can Rely On" content="We design, optimize, and migrate PostgreSQL and SQL databases, and build the reporting, analytics, and data integration your business runs on." />
                <KeyFeatures KeyFeaturesData={KeyFeaturesData} />
                <AdditionalServices AdditionalServicesData={AdditionalServicesData} img="assets/img/offerings/Product_Development.jpg" />
                <OurApproach OurApproachData={OurApproachData} title="Our Process" bgColors={bgColors} />
            </main>
            <MainFooter />
        </>
    );
};

export default DatabaseDataSolutions;
